import FlexPane from './_flex-pane.js'
import BannerPromotions from './_banner-promotions.js'
import SportIcons from './_sport-icons.js'
import KeyValueMap from './_key-value-map.js'
import PageHeader from './_page-header.js'
import SportTabSelector from './_sport-tab-selector.js'
import EmptyContent from './_empty-content.js'

export default {
  name: 'SportPage',
  values: {
    primaryContentContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    secondaryContentContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    leftPromotions: {
      configSet: BannerPromotions,
      configValues: {},
    },
    hideBreadcrumbs: false,
    _mobile_hideBreadcrumbs: true,
    documentHeadMetaFactory: undefined,
    sportIcons: {
      configSet: SportIcons,
      configValues: {},
    },
    sportBackgroundImages: {
      configSet: KeyValueMap,
      configValues: {},
    },
    pageHeader: {
      configSet: PageHeader,
      configValues: {
        headerContainer: {
          style: {
            minHeight: '96px',
            padding: '0 0 4px 0',
            alignItems: 'normal',
            flexDirection: 'column',
          },
        },
        labelContainer: {
          style: {
            padding: '16px 12px 0',
          },
        },
      },
    },
    sportTabSelector: {
      configSet: SportTabSelector,
      configValues: {
        tabs: {
          buttonScrollPane: {
            contentContainer: {
              style: {
                _mobile_padding: '0',
              },
            },
            scrollItemIntoView: true,
          },
          style: {
            container: {
              height: '44px',
              padding: 0,
            },
          },
          item: {
            selected: {
              style: {
                base: {
                  flexGrow: 0,
                  minWidth: '44px',
                  padding: '0 12px',
                },
              },
            },
            unselected: {
              style: {
                base: {
                  flexGrow: 0,
                  minWidth: '44px',
                  padding: '0 12px',
                },
              },
            },
            indicator: {
              style: {
                base: {
                  height: '2px',
                },
              },
            },
          },
        },
      },
    },
    emptyContent: {
      configSet: EmptyContent,
      configValues: {},
    },
  },
  meta: {
    extendable: true,
  },
}
